import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=fad3fa10&scoped=true"
var script = {}
import style0 from "./Facebook.vue?vue&type=style&index=0&id=fad3fa10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad3fa10",
  null
  
)

export default component.exports